@use "variables" as *;

.mainDiv {
  font-size: $fontSize-s;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
}
